export const webApiUrl = "https://maxbook5.net/";